import { resetRegionFilters } from "../functions/location-filters";
import { resetSearchFilters } from "../functions/location-search";
import { updateMap } from "./maps";

export const toggleResetButton = (showResetButton, locationsContainer) => {
    const labelText = showResetButton ? 'Results' : 'All Locations';
    const mod = locationsContainer.closest('.js-location-search-module');
    const label = mod.querySelector('.js-locations-reset__label');
    const divider = mod.querySelector('.js-locations-reset__divider');
    const trigger = mod.querySelector('.js-locations-reset__trigger');

    // Update the label text
    label.textContent = labelText;
    
    if ( showResetButton ) {
        divider.classList.remove('!hidden');
        trigger.classList.remove('!hidden');
    } else {
        divider.classList.add('!hidden');
        trigger.classList.add('!hidden');
    }
};

export const resetLocationFilters = async (mod) => {
    if ( mod ) {
        const resetTrigger = mod.querySelector('.js-locations-reset__trigger');
        const locationsContainer = mod.querySelector('.js-loc-search-results-container');

        if ( resetTrigger ) {
            resetTrigger.addEventListener('click', (e) => {
                e.preventDefault();

                resetLocationFilterClick(mod, locationsContainer);
            });
        }
    }
};

const resetLocationFilterClick = async (mod, locationsContainer) => {
    const mapElem = mod.querySelector('.js-loc-search-map');
    const regionFilterBtnContainer = mod.querySelector('.js__show-regions-popup-container');

    // Reset the region filters
    await resetRegionFilters(mod);

    // Reset the search input
    await resetSearchFilters(mod);

    // Reset the filters
    toggleResetButton(false, locationsContainer);

    // Show the regional filter button
    if ( regionFilterBtnContainer ) {
        regionFilterBtnContainer.classList.remove('hidden');
    }

    // Update the map
    updateMap(mapElem);
}